// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.compare-faculty-member {
  width: 100%;
}
.compare-faculty-member .header {
  font-size: 40px;
}
.compare-faculty-member .compare-list {
  margin-top: 20px;
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.compare-faculty-member .compare-list .compare-item {
  position: relative;
  width: 24%;
  border: 1px solid var(--benchmarking-hover);
  background: var(--benchmarking-hover);
  padding: 10px;
  border-radius: 20px;
  height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
}
.compare-faculty-member .compare-list .compare-item .icon {
  width: 100%;
  display: flex;
  justify-content: center;
}
.compare-faculty-member .compare-list .compare-item .icon svg {
  width: 50%;
  height: 120px;
}
.compare-faculty-member .compare-list .compare-item button {
  position: absolute;
  bottom: 10px;
  width: 170px;
  height: 45px;
  border: 1px solid var(--benchmarking-color);
  border-radius: 20px;
  margin-bottom: 20px;
}
.compare-faculty-member .compare-list .compare-item button:hover {
  cursor: pointer;
  background-color: var(--benchmarking-color);
  color: white;
}
.compare-faculty-member .compare-list .compare-item-filled {
  position: relative;
  width: 24%;
  background: var(--benchmarking-hover);
  padding: 10px;
  border-radius: 20px;
  height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.compare-faculty-member .compare-list .compare-item-filled .filters-keyword {
  width: 100%;
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}
.compare-faculty-member .compare-list .compare-item-filled .filters-keyword p {
  font-size: 14px;
  color: var(--dark-grey);
  margin-top: 4px !important;
}
.compare-faculty-member .compare-list .compare-item-filled img {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}
.compare-faculty-member .compare-list .compare-item-filled .bio {
  padding: 10px !important;
}
.compare-faculty-member .compare-list .compare-item-filled .bio p {
  color: var(--dark-grey);
  text-align: justify;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-size: 14px;
}
.compare-faculty-member .compare-list .compare-item-filled .name {
  margin-top: 5px !important;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
}
.compare-faculty-member .compare-list .compare-item-filled .institution {
  margin-top: 10px !important;
  font-size: 14px;
  text-align: center;
  text-decoration: underline;
}
.compare-faculty-member .compare-list .compare-item-filled .position {
  font-size: 14px;
  color: var(--dark-grey);
  text-align: center;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.compare-faculty-member .compare-list .compare-item-filled .keywords {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.compare-faculty-member .compare-list .compare-item-filled .basic-stat-faculty {
  position: absolute;
  bottom: 75px;
  margin-top: 10px;
  width: 85%;
}
.compare-faculty-member .compare-list .compare-item-filled .basic-stat-faculty .statistic-item {
  font-size: 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 3px;
}
.compare-faculty-member .compare-list .compare-item-filled .basic-stat-faculty .statistic-item .ant-progress-steps-item {
  width: 8px !important;
  border-radius: 50%;
}
.compare-faculty-member .compare-list .compare-item-filled .basic-stat-faculty .statistic-item-max .ant-progress-steps-item-active {
  background: #22bb33;
}
.compare-faculty-member .compare-list .compare-item-filled button {
  position: absolute;
  bottom: 0px;
  width: 170px;
  height: 45px;
  border: none;
  background-color: var(--explore-color);
  color: white;
  border-radius: 20px;
  cursor: pointer;
  margin-bottom: 20px;
}
.compare-faculty-member .graphs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
}
.compare-faculty-member .graphs .citation-chart {
  width: 58%;
}
.compare-faculty-member .graphs .radar-chart {
  width: 40%;
}

.add-compare-button .add-compare-path {
  stroke: #28303f;
}

.add-compare-button-check {
  fill: var(--benchmarking-color);
}
.add-compare-button-check .add-compare-path {
  stroke: #28303f;
}

.no-add {
  border: 1px solid var(--benchmarking-color);
  border-radius: 50%;
  fill: var(--benchmarking-color);
}
.no-add .add-compare-path {
  stroke: white;
  fill: var(--benchmarking-color);
}

.add-compare-button:hover {
  cursor: pointer;
  border: 1px solid var(--benchmarking-color);
  border-radius: 50%;
  fill: var(--benchmarking-color);
}
.add-compare-button:hover .add-compare-path {
  stroke-width: 1.5;
  stroke: white;
}

.data-content {
  height: 45vh;
  overflow-y: scroll;
  overflow-x: hidden;
}

.data-content::-webkit-scrollbar-track {
  background-color: transparent;
}

.data-content::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}

.data-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--light-grey);
}`, "",{"version":3,"sources":["webpack://./src/Benchmarking/Scss/CompareFaculty.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AAAE;EACE,eAAA;AAEJ;AAAE;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;AAEJ;AADI;EACE,kBAAA;EACA,UAAA;EACA,2CAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,8BAAA;AAGN;AAFM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAIR;AAHQ;EACE,UAAA;EACA,aAAA;AAKV;AAFM;EACE,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,mBAAA;AAIR;AAFM;EACE,eAAA;EACA,2CAAA;EACA,YAAA;AAIR;AADI;EACE,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAGN;AAFM;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AAIR;AAHQ;EACE,eAAA;EACA,uBAAA;EACA,0BAAA;AAKV;AAFM;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AAIR;AAFM;EACE,wBAAA;AAIR;AAHQ;EACE,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,eAAA;AAKV;AAFM;EACE,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAIR;AAFM;EACE,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;AAIR;AAFM;EACE,eAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAIR;AAFM;EACE,gBAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;AAIR;AAFM;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;AAIR;AAHQ;EACE,eAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAKV;AAJU;EACE,qBAAA;EACA,kBAAA;AAMZ;AAFU;EACE,mBAAA;AAIZ;AAAM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,sCAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAER;AAEE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AACI;EACE,UAAA;AACN;AACI;EACE,UAAA;AACN;;AAKE;EACE,eAAA;AAFJ;;AAKA;EACE,+BAAA;AAFF;AAGE;EACE,eAAA;AADJ;;AAIA;EACE,2CAAA;EACA,kBAAA;EACA,+BAAA;AADF;AAEE;EACE,aAAA;EACA,+BAAA;AAAJ;;AAGA;EACE,eAAA;EACA,2CAAA;EACA,kBAAA;EACA,+BAAA;AAAF;AACE;EACE,iBAAA;EACA,aAAA;AACJ;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AACF;;AACA;EACE,6BAAA;AAEF;;AACA;EACE,UAAA;EACA,6BAAA;AAEF;;AACA;EACE,mBAAA;EACA,mCAAA;AAEF","sourcesContent":[".compare-faculty-member {\n  width: 100%;\n  .header {\n    font-size: 40px;\n  }\n  .compare-list {\n    margin-top: 20px;\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    .compare-item {\n      position: relative;\n      width: 24%;\n      border: 1px solid var(--benchmarking-hover);\n      background: var(--benchmarking-hover);\n      padding: 10px;\n      border-radius: 20px;\n      height: 60vh;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: space-between;\n      .icon {\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        svg {\n          width: 50%;\n          height: 120px;\n        }\n      }\n      button {\n        position: absolute;\n        bottom: 10px;\n        width: 170px;\n        height: 45px;\n        border: 1px solid var(--benchmarking-color);\n        border-radius: 20px;\n        margin-bottom: 20px;\n      }\n      button:hover {\n        cursor: pointer;\n        background-color: var(--benchmarking-color);\n        color: white;\n      }\n    }\n    .compare-item-filled {\n      position: relative;\n      width: 24%;\n      background: var(--benchmarking-hover);\n      padding: 10px;\n      border-radius: 20px;\n      height: 60vh;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      .filters-keyword {\n        width: 100%;\n        display: flex;\n        align-items: flex-start;\n        flex-wrap: wrap;\n        p {\n          font-size: 14px;\n          color: var(--dark-grey);\n          margin-top: 4px !important;\n        }\n      }\n      img {\n        width: 100px;\n        height: 100px;\n        border-radius: 50%;\n        object-fit: cover;\n      }\n      .bio {\n        padding: 10px !important;\n        p {\n          color: var(--dark-grey);\n          text-align: justify;\n          display: -webkit-box;\n          -webkit-line-clamp: 5;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n          font-size: 14px;\n        }\n      }\n      .name {\n        margin-top: 5px !important;\n        font-size: 20px;\n        font-weight: 600;\n        text-align: center;\n      }\n      .institution {\n        margin-top: 10px !important;\n        font-size: 14px;\n        text-align: center;\n        text-decoration: underline;\n      }\n      .position {\n        font-size: 14px;\n        color: var(--dark-grey);\n        text-align: center;\n        display: -webkit-box;\n        -webkit-line-clamp: 1;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n      }\n      .keywords {\n        margin-top: 20px;\n        width: 100%;\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: center;\n      }\n      .basic-stat-faculty {\n        position: absolute;\n        bottom: 75px;\n        margin-top: 10px;\n        width: 85%;\n        .statistic-item {\n          font-size: 13px;\n          display: flex;\n          justify-content: space-between;\n          align-items: center;\n          margin-bottom: 3px;\n          .ant-progress-steps-item {\n            width: 8px !important;\n            border-radius: 50%;\n          }\n        }\n        .statistic-item-max {\n          .ant-progress-steps-item-active {\n            background: #22bb33;\n          }\n        }\n      }\n      button {\n        position: absolute;\n        bottom: 0px;\n        width: 170px;\n        height: 45px;\n        border: none;\n        background-color: var(--explore-color);\n        color: white;\n        border-radius: 20px;\n        cursor: pointer;\n        margin-bottom: 20px;\n      }\n    }\n  }\n  .graphs {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 30px;\n    .citation-chart {\n      width: 58%;\n    }\n    .radar-chart {\n      width: 40%;\n    }\n  }\n}\n\n.add-compare-button {\n  .add-compare-path {\n    stroke: #28303f;\n  }\n}\n.add-compare-button-check {\n  fill: var(--benchmarking-color);\n  .add-compare-path {\n    stroke: #28303f;\n  }\n}\n.no-add {\n  border: 1px solid var(--benchmarking-color);\n  border-radius: 50%;\n  fill: var(--benchmarking-color);\n  .add-compare-path {\n    stroke: white;\n    fill: var(--benchmarking-color);\n  }\n}\n.add-compare-button:hover {\n  cursor: pointer;\n  border: 1px solid var(--benchmarking-color);\n  border-radius: 50%;\n  fill: var(--benchmarking-color);\n  .add-compare-path {\n    stroke-width: 1.5;\n    stroke: white;\n  }\n}\n.data-content {\n  height: 45vh;\n  overflow-y: scroll;\n  overflow-x: hidden;\n}\n.data-content::-webkit-scrollbar-track {\n  background-color: transparent;\n}\n\n.data-content::-webkit-scrollbar {\n  width: 5px;\n  background-color: transparent;\n}\n\n.data-content::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  background-color: var(--light-grey);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
